/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GCPRegionsEnum } from './gCPRegionsEnum';
import { GcpRoleAndPrincipalOperationEnum } from './gcpRoleAndPrincipalOperationEnum';


export interface ModifyRepositoryPrincipalSpec { 
    operation: GcpRoleAndPrincipalOperationEnum;
    version?: string;
    region_id: GCPRegionsEnum;
    /**
     * principals to add/remove
     */
    principals: Array<string>;
}
export namespace ModifyRepositoryPrincipalSpec {
}


